$(document).ready(function() {
AOS.init({
  duration: 1200
});
jQuery('.cart_template-wrapper,.cart__footer-wrapper').wrapAll('<div class="main-cart"><div class="row"></div></div>');
/*--------------- Scroll to top js -------------------*/
(function($) { "use strict";

              $(document).ready(function(){"use strict";

                                           var progressPath = document.querySelector('.progress-wrap path');
                                           var pathLength = progressPath.getTotalLength();
                                           progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
                                           progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                                           progressPath.style.strokeDashoffset = pathLength;
                                           progressPath.getBoundingClientRect();
                                           progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
                                           var updateProgress = function () {
                                             var scroll = $(window).scrollTop();
                                             var height = $(document).height() - $(window).height();
                                             var progress = pathLength - (scroll * pathLength / height);
                                             progressPath.style.strokeDashoffset = progress;
                                           }
                                           updateProgress();
                                           $(window).scroll(updateProgress);	
                                           var offset = 50;
                                           var duration = 550;
                                           jQuery(window).on('scroll', function() {
                                             if (jQuery(this).scrollTop() > offset) {
                                               jQuery('.progress-wrap').addClass('active-progress');
                                             } else {
                                               jQuery('.progress-wrap').removeClass('active-progress');
                                             }
                                           });				
                                           jQuery('.progress-wrap').on('click', function(event) {
                                             event.preventDefault();
                                             jQuery('html, body').animate({scrollTop: 0}, duration);
                                             return false;
                                           })
                                          });

             })(jQuery); 
/*-------------------- END ------------------*/
jQuery('.nav-toggle').click(function(event) {
  jQuery(this).toggleClass('active');
  event.stopPropagation();
  jQuery(' #tt-megamenu .tt-mega_menu').slideToggle("2000");
  jQuery('body').toggleClass("open-header");
});
jQuery("#tt-megamenu .tt-mega_menu").on("click", function(event) {
  event.stopPropagation();
  jQuery(this).removeClass('active');
});	
jQuery("#tt-megamenu .tt-mega_menu").hover(
  function () {
    jQuery('body').addClass("menu_hover");
  },
  function () {
    jQuery('body').removeClass("menu_hover");
  }
);
/*-------------------- Filter toggle ------------------*/
jQuery(".filter-toggle").on("click" , function(e){
  e.preventDefault();
  jQuery(this).toggleClass("active");
  jQuery(".filter-toggle-wrap").slideToggle("is-visible");
})
var filter = jQuery(this).find('.full_width .sorting_wrapper');
jQuery(this).find('.filter-toggle').insertBefore(filter);
/*-------------------- END ------------------*/
jQuery('.product-single__thumbs img').on('click', function () {
  var src = jQuery(this).attr('src');
  if (src != '') {
    jQuery(this).closest('.product-wrapper').find('img.grid-view-item__image').first().attr('src', src);
  }
  jQuery(this).parent('.grid-item').addClass('open').siblings('.grid-item').removeClass('open');
});
/*-------------------- video -------------------*/
var p = jQuery(".popup_overlay");
jQuery(".play-icone").click(function() {
  jQuery("body").addClass("popup-toggle");
  p.css("display", "block");
});
p.click(function(event) {
  e = event || window.event;
  if (e.target == this) {
    jQuery(p).css("display", "none");
    jQuery('body').removeClass('popup-toggle'); 
  }
});
jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").click(function() {
  p.css("display", "none");
  jQuery('body').removeClass('popup-toggle'); 
});
//video popup
function toggleVideo(state) {
  // if state == 'hide', hide. Else: show video
  var div = document.getElementById("popupVid");
  var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
  //div.style.display = state == 'hide' ? 'none' : '';
  func = state == "hide" ? "pauseVideo" : "playVideo";
  iframe.postMessage(
    '{"event":"command","func":"' + func + '","args":""}',
    "*"
  );
}
jQuery(".play-icone").click(function() {
  p.css("visibility", "visible").css("opacity", "1");
});
p.click(function(event) {
  e = event || window.event;
  if (e.target == this) {
    jQuery(p)
    .css("visibility", "hidden")
    .css("opacity", "0");
    toggleVideo("hide");
  }
});
jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").click(function() {
  p.css("visibility", "hidden").css("opacity", "0");
  toggleVideo("hide");
});
/*------------------------- Checkout button --------------------*/
jQuery(".shopify-payment-button .shopify-payment-button__button").prepend( jQuery("<i class='mdi mdi-cart-outline'></i>"));
/*----------------------------------------------*/
var w_width = $(window).width();
$('.slider-content-main-wrap').css('width',w_width);
if($('.site-header').hasClass('header_transaparent')){
  $('body.template-index').addClass('header_transaparent')
}

var img_id = jQuery('.product-single__thumbs .slick-active.slick-current').find('.product-single__thumb').data('id');
if(jQuery('.product-lightbox-btn').hasClass(img_id)){
  jQuery('.product-lightbox-btn.'+img_id).show();
}
/*----------------------- filter ----------------------*/
jQuery(".filter-left").on("click" , function(e){
  e.preventDefault();
  jQuery(this).toggleClass("active");
  jQuery(".off-canvas.position-left").addClass("is-open");
  jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
});
jQuery(".filter-right").on("click" , function(e){
  e.preventDefault();
  jQuery(this).toggleClass("active");
  jQuery(".off-canvas.position-right").addClass("is-open");
  jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
});
jQuery(".off-canvas .sidebar_close").on("click" , function(e){
  e.preventDefault();
  jQuery(".off-canvas.position-left").removeClass("is-open");
  jQuery(".off-canvas.position-right").removeClass("is-open");
  jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
});
jQuery(".is-overlay-fixed").on("click" , function(e){
  e.preventDefault();
  jQuery(".filter-left").trigger('click');
  jQuery(".filter-right").trigger('click');
  jQuery(".off-canvas.position-left").removeClass("is-open");
  jQuery(".off-canvas.position-right").removeClass("is-open");
  jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
});
$('.product-360-button a').magnificPopup({
  type: 'inline',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  disableOn: false,
  preloader: false,
  fixedContentPos: false,
  callbacks: {
    open: function() {
      $(window).resize()
    }
  }
});
countDownIni('.flip-countdown,.js-flip-countdown'); 
/*--------------- popup Video ---------------------*/
$('.popup-video').magnificPopup({
  disableOn: 300,
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});
if ($('a.product-lightbox-btn').length > 0 || $('a.product-video-popup').length > 0) {
  $('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1]
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
    },
    callbacks: {
      beforeOpen: function() {
        var productVideo = $('.product-video-popup').attr('href');
        if (productVideo) {
          this.st.mainClass = 'has-product-video';
          var galeryPopup = $.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: 'iframe'
          });
          galeryPopup.updateItemHTML();
        }
      },
      open: function() {}
    }
  });
}
$('.design_3 .product-img,.design_5 .pro_img').magnificPopup({
  delegate: 'a', // child items selector, by clicking on it popup will open
  type: 'image',
  tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
  removalDelay: 300,
  closeOnContentClick: true,
  gallery: {
    enabled: true,
    navigateByImgClick: false,
    preload: [0, 1]
  },
  image: {
    verticalFit: false,
    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
  },
  callbacks: {
    beforeOpen: function() {
      var productVideo = $('.product-video-popup').attr('href');
      if (productVideo) {
        this.st.mainClass = 'has-product-video';
        var galeryPopup = $.magnificPopup.instance;
        galeryPopup.items.push({
          src: productVideo,
          type: 'iframe'
        });
        galeryPopup.updateItemHTML();
      }
    },
    open: function() {}
  }
});
$('body').on('click', '.product-lightbox-btn', function(e) {
  $('.product-wrapper-owlslider').find('.owl-item.active a').click();
  e.preventDefault();
});
/*-------------- Quantity Start -------------------*/ 
$('.qtyplus').on('click',function(e){
  e.preventDefault();     
  var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
  var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
  var update = jQuery('.cart-update .quantity').data("item-id");
  if (!isNaN(currentVal)) {
    jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal + 1);
  } else {
    jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
  }

});
$(".qtyminus").on('click',function(e) {
  e.preventDefault();
  var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
  var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
  if (!isNaN(currentVal) && currentVal > 1) {
    jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal - 1);
  } else {
    jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
  }

});
  
/*---------------- END ------------------*/
$("#navToggle").on('click',function(e) {
  jQuery(this).next('.Site-navigation').slideToggle(500);
});
$(".menu_toggle_wrap #navToggle").on('click',function(e) {
  jQuery(this).parent().next('.Site-navigation').slideToggle(500);
});

jQuery("body.footer_style_1 .footer_toggle").on("click" , function(e){
  jQuery('#shopify-section-footer-model-1').addClass('toggle-footer'); 
  jQuery("body").addClass("footer1-open");
  e.preventDefault();
});

jQuery("body.footer_style_1 .footer_close_toggle").on("click" , function(e){ 
  jQuery('#shopify-section-footer-model-1').removeClass('toggle-footer');
  jQuery("body").removeClass("footer1-open");
  e.preventDefault();
});
jQuery(".header_1 .fullscreen_header_toggle").on("click" , function(e){
  jQuery(this).toggleClass("active");
  //     jQuery("body").toggleClass("fullnav-open header_1");      
  e.preventDefault();
});
/*-------------- Search js ----------------*/
jQuery(".site-header__search.search-full .serach_icon").on('click',function(e){
  e.preventDefault();
  jQuery(this).toggleClass('active'); 
  jQuery('body').toggleClass('search_full_active'); 
  jQuery( ".search-full-screen" ).slideToggle( "slow" );
  jQuery('.full-search-wrapper').addClass('search-overlap');
  jQuery('.myaccount  .dropdown-toggle').removeClass("open");
  jQuery( '.myaccount  .customer_account' ).slideUp( "fast" );  
  jQuery('.site-header .site-header_cart_link').removeClass("active");  
  jQuery( ".fixed-cart-wrap" ).removeClass('active');
  jQuery(".search-bar > input").focus();
  jQuery('body').toggleClass('search_toggle'); 
  jQuery('body').removeClass('account-toggle');
  jQuery('body').removeClass('cart_toggle');
});
jQuery(".site-header__search.search-full .close-search").on('click',function(){
  jQuery('.site-header__search.search-full .serach_icon').removeClass('active');
  jQuery('.full-search-wrapper').removeClass('search-overlap');   
  jQuery('body').removeClass('search_full_active');
  jQuery('body').removeClass('search_toggle'); 
  jQuery( ".search-full-screen" ).slideUp( "slow" );
});

  
  jQuery('.category_feature .cat_content:odd').addClass('odd');
  jQuery('.category_feature .cat_content:even').addClass('even');

  jQuery('.category_feature .cat_content.odd .main_cat_content').each(function(index, element) {
    var html = '';
     html += '<div class="ttcat-content right-block">' + jQuery(element).find('.right-block').html() + '</div>';
    html += '<div class="collection_img left-block">' + jQuery(element).find('.left-block').html() + '</div>';
    jQuery(element).html(html);
  });

/*-------------------- Myaccount -----------------*/
jQuery(".myaccount  span.dropdown-toggle").on('click',function(event){   
  event.preventDefault();
  jQuery( ".customer_account" ).slideToggle( "fast" );
  jQuery(this).toggleClass('open');
  jQuery('body').toggleClass('account-toggle');  
  jQuery( ".search_wrapper" ).slideUp( "fast" );
  jQuery('.site-header__search:not(.search-full) .serach_icon').removeClass('active');
  jQuery('body').removeClass('search_full_active'); 
  jQuery('body').removeClass('currency-open');
  jQuery('body').removeClass('language-open');
  jQuery('.site-header .site-header_cart_link').removeClass("active");    
  jQuery( ".fixed-cart-wrap" ).removeClass('active');
//     jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
//     jQuery( ".header_language .disclosure-list" ).slideUp( "fast" ); 
  jQuery('body').removeClass('search_toggle'); 
  jQuery('body').removeClass('cart_toggle');
});

jQuery(".header_language .disclosure__toggle").on("click", function (event) {     
  event.preventDefault();  
  if(jQuery( window ).width() > 992) {
    jQuery('body').toggleClass('language-open');
    jQuery('body').removeClass('currency-open');
    jQuery( "body" ).removeClass( 'myaccount_active' );
    jQuery('body').removeClass('cart_toggle');
    jQuery('.currency_wrapper').removeClass('active');
    jQuery( ".disclosure-list" ).slideToggle( "fast" );
    jQuery(this).toggleClass('active');  
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery( ".fixed-cart-wrap" ).removeClass('active');
  }
});

$(".header_currency .currency_wrapper.dropdown-toggle").on("click", function (event) {     
  event.preventDefault();
  if(jQuery( window ).width() > 992) {
    jQuery('body').toggleClass('currency-open');
    jQuery('body').removeClass('language-open');
    jQuery( "body" ).removeClass( 'myaccount_active' );
    jQuery('body').removeClass('cart_toggle');
    jQuery('.disclosure__toggle').removeClass('active');
    jQuery( ".currencies.flag-dropdown-menu" ).slideToggle( "fast" );
    $(this).toggleClass('active'); 
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".header_language .disclosure-list" ).slideUp( "fast" ); 
    jQuery( ".fixed-cart-wrap" ).removeClass('active');
  }
});
/*-------------------- END -----------------*/
var brandsowl = $("body:not(.rtl) #brands_list_slider");
var  brandsowlrtl = $("body.rtl #brands_list_slider");
brandsowl.owlCarousel({
  items : 7 , //10 items above 1000px browser width
  dots: false,
  rewind:false,
  autoplay:true,
  autoplayHoverPause:true,
  nav: true,
  loop: false,
  responsive: {
    100: {
      items: 2
    },
    320: {
      items: 2
    },
    544: {
      items: 3
    },
    992: {
      items: 4
    },
      1099: {
      items: 5
    },
    1200: {
      items: 5
    }
  }
});
brandsowlrtl.owlCarousel({
  items : 7 , //10 items above 1000px browser width
  dots: false,
  rewind:true,
  nav: true,
  autoplay:true,
  autoplayHoverPause:true,
  loop: true,
  rtl: true,
  responsive: {
    100: {
      items: 2
    },
    320: {
      items: 2
    },
    544: {
      items: 3
    },
    992: {
      items: 4
    },
       1099: {
      items: 5
    },
    1200: {
      items: 5
    }
  }
});
$(".brands_next").click(function(){
  brandsowl.trigger('owl.next');
});
$(".brands_prev").click(function(){
  brandsowl.trigger('owl.prev');
});
$(".brands_next").click(function(){
  brandsowlrtl.trigger('owl.next');
});
$(".brands_prev").click(function(){
  brandsowlrtl.trigger('owl.prev');
});

var p_col = jQuery('.slider-specialproduct').data('col');
if(jQuery("body").hasClass('disable_menutoggle')){
  $('body.disable_menutoggle .slider-specialproduct').owlCarousel({
    items : p_col, //10 items above 1000px browser width
    nav : false,
    dots : true,
    responsive: {
      100: {
        items: 1
      }, 
      319: {
        items: 2
      },
      700: {
        items: 3
      },
      992: {
        items: 3
      },
      1200: {
        items: 4
      },
      1400: {
        items: p_col
      }
    },
  });
}else{
  $('body .slider-specialproduct').owlCarousel({
    items : p_col, //10 items above 1000px browser width
    nav : false,
    dots : true,
    responsive: {
      100: {
        items: 1
      }, 
      319: {
        items: 2
      },
      700: {
        items: 3
      },
      992: {
        items: 3
      },
      1200: {
        items: 4
      },
      1400: {
        items: p_col
      }
    },
  });
}


  $('body:not(.rtl) .ttcmsservices .service-block').owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: false,
    dots: false,
    loop: false,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      480: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 4
      },
      1279: {
        items: 4
      }
    }
  });
  $('body.rtl .ttcmsservices .service-block').owlCarousel({
    items: 4, //1 items above 1000px browser width
    nav: false,
    rtl: true,
    dots: false,
    autoplay: true,
    loop: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      480: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 4
      },
      1279: {
        items: 4
      }
    }
  });

    $('.image-content').owlCarousel({
  items :2, //1 items above 1000px browser width
  nav : true,
    loop:true,  
  dots : false,
  autoplay:false,
  autoWidth:true,
  responsive: {
    1200: {
      items: 1
    },
    991: {
      items: 1
    },
    768: {
      items: 2
    },
    481: {
      items: 2
    },
    100: {
      items: 1
    }
  }
});

  $('#cmsgallery').each(function () { 
  if($(this).find('.owl-nav').hasClass('disabled')){
    $(this).find('.customNavigation').hide();
  }else{
    $(this).find('.customNavigation').show();
  }
});
$("#cmsgallery .customNavigation .next").click(function(){
  var wrap = $(this).closest('#cmsgallery');
  $(wrap).find('.image-content').trigger('next.owl');
});
$("#cmsgallery .customNavigation .prev").click(function(){
  var wrap = $(this).closest('#cmsgallery');
  $(wrap).find('.image-content').trigger('prev.owl');
});

/*-------------------------gallery------------------*/
var banner = $(".product-thumb .slider-nav");
banner.owlCarousel({
  items : 1 , //10 items above 1000px browser width
  dots: false,
  loop: true,
  nav: true,
  rewind:true,
  autoplay:true,
  autoplayHoverPause: true,
  responsive: {
    100: {
      items: 1
    },
    481: {
      items: 1
    },
    992: {
      items: 1
    },
    1200: {
      items: 1
    },
    1300: {
      items: 1
    }
  }
});  

$('body #ttcmsservices .block_content').owlCarousel({
  items :4, //1 items above 1000px browser width
  nav : false,
  dots : true,
  loop: false,
  autoplay:false,
  rewindNav:true,
  responsive: {
    1200: {
      items: 4
    },
    1050: {
      items:3
    },
    991: {
      items: 3
    },
    767: {
      items: 3
    },
    575: {
      items:2
    },
    481: {
      items: 2
    },
        320: {
      items: 1
    },
    100: {
      items: 1
    }
  }
});
$('.cms-block-slider').owlCarousel({             
  items: 2,
  nav : false,
  dots : false,
  autoplay:false,
  loop:false,
  autoplayHoverPause: false,
  responsive: {
    100: {
      items: 1
    },
    481: {
      items: 1
    },
    575: {
      items: 2
    },
    992: {
      items: 2
    },
    1200: {
      items: 2
    }
  }
});

$('body .about-services .block_content').owlCarousel({
  items :3, //1 items above 1000px browser width
  nav : false,
  dots : true,
  loop: false,
  autoplay:false,
  rewindNav:true,
  responsive: {
    1200: {
      items: 3
    },
    991: {
      items: 2
    },
    768: {
      items: 2
    },
    481: {
      items: 1
    },
    100: {
      items: 1
    }
  }
});

  $('#tt-megamenu .list_product_menu_content').owlCarousel({
  items : 5, //1 items above 1000px browser width
  nav : false,
  autoPlay:true,
  autoplaySpeed:1000,
  stopOnHover: false,
  loop: false,
  dots : true,
  responsive: {
    768: {
      items: 5
    },
    360: {
      items: 2
    },
    100: {
      items: 1
    }
  }
});

 $('body .testimonials_wrap').owlCarousel({
  stagePadding: 200,
  loop:true,
  startPosition:0,
  center: true,
  dots:false,
  items:2,
  lazyLoad: true,
  nav:false,
  responsive:{
    0:{
      items:1,
      stagePadding: 0
    },
    600:{
      items:1,
      stagePadding: 0
    },
    992:{
      items:1,
      stagePadding: 200
    },
    1200:{
      items:1,
      stagePadding: 300
    },
    1700:{
      items:1,
      stagePadding: 560
    }
  }
});

  $('body .category_feature').owlCarousel({             
  items: 1,
  nav : true,
  dots : false,
  autoplay:false,
  loop:true,
  autoplayHoverPause: false,
  responsive: {
    100: {
      items: 1
    },
    460: {
      items: 1
    },
    481: {
      items: 2
    },
    721: {
      items: 2
    },
    768: {
      items: 2
    },
    920:{
      items: 2
    },
    992: {
      items: 3
    },      
    1199: {
      items: 3
    },
      1300: {
      items: 3
    }
  }
});

$('.category_feature1').owlCarousel({             
  items: 5,
  nav : false,
  dots : false,
  autoplay:true,
  loop:true,
  autoplayHoverPause: false,
  lazyLoad: true,
  smartSpeed: 1000,
  autoplayTimeout: 3000,
  responsive: {
    100: {
      items: 1
    },
    320: {
      items: 2
    },
    481: {
      items: 3
    },
    768: {
      items: 4
    },
    1300: {
      items: 5
    }
  }
});
$('body:not(.rtl) .widget_top_rated_products .top-products').owlCarousel({
  items : 1, //1 items above 1000px browser width
  nav : true,
  dots : true,
  loop: false,
  autoplay:true,
  rtl:false,
  responsive: {
    1279: {
      items: 1
    },
    600: {
      items: 1
    }
  }
});
$('body.rtl .widget_top_rated_products .top-products').owlCarousel({
  items : 1, //1 items above 1000px browser width
  nav : true,
  dots : true,
  loop: false,
  autoplay:true,				
  rtl:true,
  responsive: {
    1279: {
      items: 1
    },
    600: {
      items: 1
    }
  }
});
jQuery(".spr-summary-actions-newreview").on('click',function(e) {
  e.preventDefault();
  jQuery(".spr-content").slideToggle( "slow" );
});

if($('body:not(.template-index) .site-header .toggle_menu').hasClass('current-close')) {
  $('.tt-mega_menu').slideUp("2000");
}
$('.toggle_menu').click(function() {
  if($(this).hasClass('default-open') && $(window).width() < 992){
    if($(this).hasClass('current-close')) {
      $(this).addClass("current-open");
      $('body').addClass("menu-current-open");
      $(this).removeClass("current-close");
      $('.tt-mega_menu').slideToggle("2000");
    } else {
      $(this).removeClass("default-open");
      $(this).addClass("current-open");
      $('body').addClass("menu-current-open");
      $(this).removeClass("current-close");
      $('.tt-mega_menu').slideToggle("2000");
    }    
  }else if($(this).hasClass('default-open')){
    if($(this).hasClass('current-close')) {
      $(this).addClass("current-open");
      $('body').addClass("menu-current-open");
      $(this).removeClass("current-close");
      $('.tt-mega_menu').slideToggle("2000");
    } else if($(this).hasClass('current-open')) {
      $(this).addClass("current-close");
      $(this).removeClass("current-open");
      $('body').removeClass("menu-current-open");
      $('.tt-mega_menu').slideToggle("2000");
    }
  }
  else{
    if($(this).hasClass('current-open')) {
      $(this).addClass("current-close");
      $('body').removeClass("menu-current-open");
      $(this).removeClass("current-open");
      $('.tt-mega_menu').slideToggle("2000");
    } else{
      $(this).addClass("current-open");
      $(this).removeClass("current-close");
      $('body').addClass("menu-current-open");
      $('.tt-mega_menu').slideToggle("2000");
    }
  }
  if($(this).hasClass('default-open') && !$('.sticky_header').hasClass('fixed')) {
    $(this).addClass("current-close");
    $(this).removeClass("default-open");
    $('.tt-mega_menu').slideToggle("2000");
  }	
  if($(this).hasClass('default-open') && $('.sticky_header').hasClass('fixed')) {
    $(this).addClass("current-open");
    $('body').addClass("menu-current-open");
    $(this).removeClass("default-open");
    $('.tt-mega_menu').slideDown("2000");
  }
});

$(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js").click(function(){$(this).addClass("loading");setTimeout(function(){$(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js").removeClass("loading")},2000)});

var prevScrollpos = window.pageYOffset;
window.onscroll = function(e) {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById("header-sticky").style.top = "0";
  } 
  else if ( $('body').hasClass('account-toggle') || $('body').hasClass('menu_hover') || $('body').hasClass('cart_toggle') || $('body').hasClass('search_toggle')) {
    document.getElementById("header-sticky").style.top = "0";
    e.stopPropagation();
  }
  else {
    document.getElementById("header-sticky").style.top = "-140px";
  }
  prevScrollpos = currentScrollPos;
}
jQuery('.product-thumb .grid-view-item__links').each(function(){  	    
  jQuery(this).hoverdir();   
});
});
/*------------------------ END ------------------------*/
jQuery(window).scroll(function () {
if(jQuery(document).height() > jQuery(window).height()){
  var scroll = jQuery(window).scrollTop();
  if (scroll > 100) {
    jQuery("#GotoTop").fadeIn();
  } else {
    jQuery("#GotoTop").fadeOut();
  }
}
});
function responsiveMenu(){
if(jQuery(window).width() < 992) {
  jQuery("#shopify-section-TT-megamenu").insertAfter(".menu_wrapper .menu_toggle_wrap .nav-toggle");
  jQuery('.sub-nav__dropdown').css('display','none');    
  jQuery(".header_1 .menu_toggle_wrap").insertBefore(".header_1 .header_logo_wrap");  
  jQuery(".header_1 #shopify-section-TT-megamenu").appendTo(".header_1 .menu_toggle_wrap");
  // jQuery(".header_1 .top_header_1_link").appendTo(".header_1 .tt-mega_menu"); 
  
//         jQuery(".header_1_wrapper .top_header_1_link .header_language").appendTo(".header_1_wrapper  .right-link-icon .myaccount .customer_account > ul");  
//     jQuery(".header_1_wrapper .top_header_1_link .header_currency").appendTo(".header_1_wrapper  .right-link-icon .myaccount .customer_account > ul");
}
else { 
  jQuery(".header_1 .menu_toggle_wrap").insertAfter(".header_1 .right-link-icon");
  // jQuery(".header_1 .top_header_1_link").prependTo(".header_1 .top_header_1");
  jQuery(".header_1 #shopify-section-TT-megamenu").insertAfter(".header_1 .header_logo_wrap");
//         jQuery(".header_1_wrapper .header_language").prependTo (".header_1_wrapper  .top_header_1_link ");
//     jQuery(".header_1_wrapper .header_currency").appendTo (".header_1_wrapper .top_header_1_link ");
}
}
jQuery(document).ready(function() {
responsiveMenu();

jQuery(".product-write-review").on('click',function(e) {
  e.preventDefault();
  $('a[href=\'#tab-2\']').trigger('click');
  jQuery('html, body').animate({
    scrollTop: jQuery(".product_tab_wrapper").offset().top-150
  }, 1000);
});
});

jQuery(window).resize(function() {
responsiveMenu();
var w_width = $(window).width();
$('.slider-content-main-wrap').css('width',w_width);
});
function height(){
var maxHeight = $(".product__media.imgs img").height();
$(".product__media.extra-video").height(maxHeight);
$(".product__media.video").height(maxHeight);
}
$(document).ready(function(){height();});
$(window).resize(function(){height();});
$(window).scroll(function() {height();});

function productcartsticky() {
if (jQuery(window).width() > 319) {
  if (jQuery(this).scrollTop() > 550) {
    jQuery('.add-to-cart-sticky').addClass("fixed");

  } else {
    jQuery('.add-to-cart-sticky').removeClass("fixed");
  }
} else {
  jQuery('.add-to-cart-sticky').removeClass("fixed");
}
}
$(document).ready(function() {
productcartsticky();
});
jQuery(window).resize(function() {
productcartsticky();
});
jQuery(window).scroll(function() {
productcartsticky();
});
function footerToggle() {
if(jQuery( window ).width() < 992) {   
  jQuery('.left-sidebar.sidebar').insertAfter('.collection_wrapper');
  jQuery('.block_newsletter').prependTo('.footer-wrap .text-left.grid');
  //     jQuery('.sidebar .collection_sidebar .sidebar-block').insertAfter('.filter-wrapper');
  jQuery(".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass( "toggle" );
  jQuery(".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(':nth-child(2)').css( 'display', 'none' );
  jQuery(".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(':nth-child(2)').css( 'display', 'block' );
  jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click");
  jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on('click',function() {
    jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
  });   
  jQuery(".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4").addClass( "toggle" );
  jQuery(".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget ").children(':nth-child(2)').css( 'display', 'none' );
  jQuery(".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active").children(':nth-child(2)').css( 'display', 'block' );
  jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").unbind("click");
  jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").on('click',function() {
    jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
  });  
}else{
  jQuery('.left-sidebar.sidebar').insertBefore('.collection_wrapper');
  //     jQuery('.sidebar-block').prependTo('.collection_sidebar');
  jQuery('.block_newsletter').appendTo('.footer-wrap .text-left.grid');
  jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind("click");
  jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass( "toggle" );
  jQuery(".sidebar .widget,.sidebar-block .widget").children(':nth-child(2)').css( 'display', 'block' );
}
}
jQuery(document).ready(function() {
footerToggle();
});
jQuery(window).resize(function() {
footerToggle();
});
function splitStr(string,seperator){
return string.split(seperator);
}
function countDownIni(countdown) {
$(countdown).each(function () {
  var countdown = $(this);
  var promoperiod;
  if (countdown.attr('data-promoperiod')) {
    promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
  } else if (countdown.attr('data-countdown')) {
    promoperiod = countdown.attr('data-countdown');
  }
  if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
    $(this).addClass('countdown-block');
    countdown.countdown(promoperiod, function (event) {
      // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
      countdown.html(event.strftime('<span><span class="left-txt">Left</span><span>%D</span><span class="time-txt">Days</span></span>' + '<span><span>%H</span><span class="time-txt">Hrs</span></span>' + '<span><span>%M</span><span class="time-txt">Min</span></span>' + '<span><span class="second">%S</span><span class="time-txt">Sec</span></span>'));
    });
  }

});
}
function hb_animated_contents() {
$(".hb-animate-element:in-viewport").each(function (i) {
  var $this = $(this);
  if (!$this.hasClass('hb-in-viewport')) {
    setTimeout(function () {
      $this.addClass('hb-in-viewport');
    }, 180 * i);
  }
});
}
$(window).scroll(function () {
hb_animated_contents();
});
// $(window).load(function () {
// hb_animated_contents();
// });
$(window).on('load', function() {
   hb_animated_contents();
})

function sidebarsticky() { 
if ($(document).width() <= 1199) {
  jQuery('.left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left').theiaStickySidebar({
    additionalMarginBottom: 30,
    additionalMarginTop: 30
  });
} 
else if ($(document).width() >= 1200) {
  jQuery('.left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left').theiaStickySidebar({
    additionalMarginBottom: 30,
    additionalMarginTop: 130
  });
}
}
jQuery(document).ready(function() {
sidebarsticky();
});
jQuery(window).resize(function() {
sidebarsticky();
});
/* responsive accordian menu*/
jQuery(function() {
var Accordion = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;
  $('ul.tt_menus_ul1 > li.tt_mm_hassub').addClass('active');
  // Variables privadas
  var links = this.el.find('li.tt_mm_hassub .mobile-nav__sublist-trigger');
  // Evento
  links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
}
Accordion.prototype.dropdown = function(e) {
  e.preventDefault();
  var $el = e.data.el;
  $this = $(this),
    $next = $this.next();

  $next.slideToggle();
  $this.parent().toggleClass('open');

  if (!e.data.multiple) {
    $el.find('li.tt_mm_hassub .tt_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
  };
}	
var accordion = new Accordion($('.tt_menus_ul1'), false);
});
jQuery(function() {
if(!$('body').hasClass('fullnav-open'))  {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    // Variables privadas
    var links = this.el.find('li.tt_mm_hassub .mobile-nav__sublist-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown);
  }
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('li.tt_mm_hassub .tt_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
    };
  }	
  var accordion = new Accordion($('.tt_menus_ul'), false);
}
});
jQuery(function() {
var Accordions = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;

  // Variables privadas
  var link = this.el.find('.toggle');
  // Evento
  link.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
}
Accordions.prototype.dropdown = function(e) {
  var $el = e.data.el;
  $this = $(this),
    $next = $this.next();

  $next.slideToggle();
  $this.parent().toggleClass('active');

  if (!e.data.multiple) {
    $el.find('.inline-list').not($next).slideUp().parent().removeClass('active');
  };
}	
var accordions = new Accordions($('.footer-column'), false);
});



$(document).ready(function(){ 
  $('.variants_img.for_mobile').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      prevArrow: '<button class="slide-arrow prev-arrow"><i class="mdi mdi-chevron-left"></i></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><i class="mdi mdi-chevron-right"></i></button>' 
    });
});

$('.product-single__photoss').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: true,
dots: true,
fade: true,
prevArrow: '<button class="slide-arrow prev-arrow"><i class="mdi mdi-chevron-left"></i></button>',
nextArrow: '<button class="slide-arrow next-arrow"><i class="mdi mdi-chevron-right"></i></button>' ,        
asNavFor: '.product-single__thumbss'
});
$('.product-single__thumbss').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.product-single__photoss',  

focusOnSelect: true
});